import { createStore, createHook, createActionsHook, createStateHook } from 'react-sweet-state';

export type ParentContent = {
	id: string;
	title: string;
	contentType: string;
};

export type Content = {
	id: string;
	type: string;
};

export type SubmitCallback = (props: { baseUrl: string; path: string }) => Promise<void>;

type State = {
	showSmartCreationModal: boolean;
	spaceKey: string;
	parentContent: ParentContent;
	content?: Content;
	stagingAreaActive: boolean;
	entryPoint: string;
	submitCallback?: SubmitCallback;
};

const initialState: State = {
	showSmartCreationModal: false,
	spaceKey: '',
	parentContent: {
		id: '',
		title: '',
		contentType: '',
	},
	content: undefined,
	stagingAreaActive: false,
	entryPoint: 'confluenceUnknown',
	submitCallback: undefined,
};

export const actions = {
	openModal:
		(
			entryPoint: string,
			spaceKey?: string,
			parentContent?: ParentContent,
			stagingAreaActive?: boolean,
			content?: Content,
			submitCallback?: SubmitCallback,
		) =>
		({ setState }: { setState: (state: Partial<State>) => void }) => {
			setState({
				showSmartCreationModal: true,
				entryPoint,
				spaceKey,
				parentContent: parentContent ?? {
					id: '',
					title: '',
					contentType: '',
				},
				content: content ?? undefined,
				stagingAreaActive: stagingAreaActive ?? false,
				submitCallback: submitCallback ?? undefined,
			});
		},
	closeModal:
		() =>
		({ setState }: { setState: (state: Partial<State>) => void }) => {
			setState({
				showSmartCreationModal: false,
				content: undefined,
				stagingAreaActive: false,
				entryPoint: 'confluenceUnknown',
			});
		},
};

export const Store = createStore({
	initialState,
	actions,
	name: 'smartCreationModalStore',
});

export const useSmartCreationModalStore = createHook(Store);

export const useSmartCreationModalActions = createActionsHook(Store);
export const useSmartCreationModalState = createStateHook(Store);
